"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Requirements = void 0;
const internal_1 = require("../../../../../internal");
const conversion_1 = require("../../../../../utils/conversion");
const internal_2 = require("../../../../../utils/internal");
/**
 * Handles all Asset Compliance Requirements related functionality
 */
class Requirements extends internal_1.Namespace {
    /**
     * @hidden
     */
    constructor(parent, context) {
        super(parent, context);
        this.add = (0, internal_2.createProcedureMethod)({ getProcedureAndArgs: args => [internal_1.addAssetRequirement, Object.assign({ asset: parent }, args)] }, context);
        this.remove = (0, internal_2.createProcedureMethod)({ getProcedureAndArgs: args => [internal_1.removeAssetRequirement, Object.assign({ asset: parent }, args)] }, context);
        this.set = (0, internal_2.createProcedureMethod)({ getProcedureAndArgs: args => [internal_1.setAssetRequirements, Object.assign({ asset: parent }, args)] }, context);
        this.reset = (0, internal_2.createProcedureMethod)({
            getProcedureAndArgs: () => [internal_1.setAssetRequirements, { asset: parent, requirements: [] }],
            voidArgs: true,
        }, context);
        this.pause = (0, internal_2.createProcedureMethod)({
            getProcedureAndArgs: () => [internal_1.togglePauseRequirements, { asset: parent, pause: true }],
            voidArgs: true,
        }, context);
        this.unpause = (0, internal_2.createProcedureMethod)({
            getProcedureAndArgs: () => [internal_1.togglePauseRequirements, { asset: parent, pause: false }],
            voidArgs: true,
        }, context);
        this.modify = (0, internal_2.createProcedureMethod)({ getProcedureAndArgs: args => [internal_1.modifyComplianceRequirement, Object.assign({ asset: parent }, args)] }, context);
    }
    // eslint-disable-next-line require-jsdoc
    get(callback) {
        return __awaiter(this, void 0, void 0, function* () {
            const { parent, context: { polymeshApi: { query: { complianceManager }, }, }, context, } = this;
            const rawAssetId = (0, conversion_1.assetToMeshAssetId)(parent, context);
            const assembleResult = ([assetCompliance, claimIssuers]) => {
                const requirements = assetCompliance.requirements.map(complianceRequirement => (0, conversion_1.complianceRequirementToRequirement)(complianceRequirement, context));
                const defaultTrustedClaimIssuers = claimIssuers.map(issuer => (0, conversion_1.trustedIssuerToTrustedClaimIssuer)(issuer, context));
                return { requirements, defaultTrustedClaimIssuers };
            };
            if (callback) {
                context.assertSupportsSubscription();
                return (0, internal_2.requestMulti)(context, [
                    [complianceManager.assetCompliances, rawAssetId],
                    [complianceManager.trustedClaimIssuer, rawAssetId],
                ], res => {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- callback errors should be handled by the caller
                    callback(assembleResult(res));
                });
            }
            const result = yield (0, internal_2.requestMulti)(context, [
                [complianceManager.assetCompliances, rawAssetId],
                [complianceManager.trustedClaimIssuer, rawAssetId],
            ]);
            return assembleResult(result);
        });
    }
    /**
     * Check whether Asset compliance requirements are paused or not
     */
    arePaused() {
        return __awaiter(this, void 0, void 0, function* () {
            const { parent, context: { polymeshApi: { query: { complianceManager }, }, }, context, } = this;
            const rawAssetId = (0, conversion_1.assetToMeshAssetId)(parent, context);
            const { paused } = yield complianceManager.assetCompliances(rawAssetId);
            return (0, conversion_1.boolToBoolean)(paused);
        });
    }
}
exports.Requirements = Requirements;
//# sourceMappingURL=Requirements.js.map